import {isNaN} from 'lodash';
import {IReportRecord} from '../../RankingReportContainer/lib/interfaces';
import {IDataGridColumn} from './interfaces';

/**
 * Download CSV Report
 */

export const getRankingReportExportData = (columns: IDataGridColumn<any>[], rankColumns: string[], nColumns: string[], records: IReportRecord[], columnNamesList?: string[], precisionColumns?: any ) => {
  const columnNames = []
  const columnTitles = []
  const visibleColumns = []
  const ColumnsPrecision = precisionColumns ? precisionColumns : [];
  const regex = /[;,/?:@&=+$#]/g // remove characters that are necessary to formulate a complete URI
  let offset = 0;
  columns.forEach((c, index) => {
    for (let i = 0; i < offset; i++) {
      columnTitles.push('') // make room for measure column
    }
    offset = 0;
    const columnID = c.property.toString().slice(8)
    if (rankColumns.includes(`rank-${columnID}`)) {
      visibleColumns.push(`rank-${columnID}`)
      columnNames.push('Rank')
      offset ++;
    }
    visibleColumns.push(c.property)
    if (c.property !== 'hierarchyRecord' && c.property !== 'hierarchyLevel') {
      columnNames.push('Measure')
    } else {
      columnNames.push('')
    }
    if (nColumns.includes(`n-${columnID}`)) {
      visibleColumns.push(`n-${columnID}`)
      columnNames.push('Number of Surveys')
      offset ++;
    }

    if (!columnNamesList) {
      columnTitles.push(c.columnTitle ? c.columnTitle : '')
    } else {
      columnTitles.push(columnNamesList[index].replace(regex, ''))
    }
  })
  const rows =  [
    columnTitles,
    columnNames,
  ]

  records.map((r) => {
    const row = []
    visibleColumns.forEach((property) => {
      let precision = 0 ;
      if (ColumnsPrecision.length) {
        const columnSelect = ColumnsPrecision.find((column) => column.id === Number(property.split('-')[1]))
        precision = columnSelect && columnSelect.precision ? columnSelect.precision : 0
      }
      let cellValue = r[property];
      const numericCellValue = parseFloat(cellValue);
      if (!isNaN(numericCellValue) && property.includes('measure')){
        cellValue = parseFloat(cellValue).toFixed(precision);
      }
      row.push(cellValue ? cellValue.toString() : '');
    })
    rows.push(row)
  })

  return rows
}
